import { useTranslation } from 'react-i18next';
import { ButtonVariant } from 'src/components/atoms/Button';

import {
  ButtonsContainer,
  Container,
  HelpText
} from 'src/components/DUP/molecules/OldWizardProofOfIncome/styles';

import { useWizardUpload } from 'src/components/DUP/molecules/WizardUpload/useWizardUpload';
import { useApplication } from 'src/context/ApplicationContext';
import { StyledButton } from 'src/pages/DUPPage/styles';
import { UnauthenticateSessionProofType } from 'src/types/api';

export const OldWizardDocumentUploadSection = (props: {
  proofType: UnauthenticateSessionProofType;
}) => {
  const {
    steps: { onFinished, goBack }
  } = useApplication();
  const { t } = useTranslation();
  const { WizardUploadEl, proofIsProcessing } = useWizardUpload(props.proofType);

  return (
    <Container>
      {WizardUploadEl}
      <HelpSection />
      <ButtonsContainer justify="space-between">
        <StyledButton
          name="back"
          onClick={() => {
            goBack();
          }}
          variant={ButtonVariant.outline}
        >
          {t('buttonLabel.back')}
        </StyledButton>
        <StyledButton
          name="next"
          isDisabled={proofIsProcessing}
          onClick={onFinished}
          variant={ButtonVariant.contained}
        >
          {t('buttonLabel.next')}
        </StyledButton>
      </ButtonsContainer>
    </Container>
  );
};

export const HelpSection = () => {
  const { t } = useTranslation();

  return (
    <HelpText>
      {t('dup.wizard.helpText.part1')}
      <a href={t('dup.wizard.helpText.howToVideoUrl')} target="_blank" rel="noreferrer">
        {t('dup.wizard.helpText.part2')}
      </a>
    </HelpText>
  );
};
